import React from "react";
import { Profile } from "../../../types/types";
import ProfileIdentity from "./profileIdentity";

interface ProfileStickyHeaderProps {
  member: Profile;
  visible: boolean;
  reviewCount?: number;
}

/**
 * Blue band that sticks to the top of the scroll area once the hero image
 * has scrolled away. Zero layout height, so nothing jumps when it appears.
 */
const ProfileStickyHeader: React.FC<ProfileStickyHeaderProps> = ({
  member,
  visible,
  reviewCount = 0,
}) => (
  <div className="sticky top-0 z-30 h-0">
    <div
      aria-hidden={!visible}
      className={`absolute inset-x-0 top-0 bg-[#5B8EFC] px-4 lg:px-8 py-3 lg:py-4 shadow-md transition-all duration-200 ease-out ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 -translate-y-2 pointer-events-none"
      }`}
    >
      <ProfileIdentity
        member={member}
        reviewCount={reviewCount}
        variant="sticky"
      />
    </div>
  </div>
);

export default ProfileStickyHeader;
